import React, { useEffect, useState } from 'react'
import { Modal } from '../layout/Modal'
import { animated, interpolate, useSprings } from 'react-spring'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { GoDot, GoDotFill } from 'react-icons/go'
import { GrDocument } from "react-icons/gr";


export const ModalProduct = ({
  title,
	isModal,
	setIsModal,
	modalPhotos = [],
	modalDescription,
	modalPhotosHeight
}) => {
	const [index, setIndex] = useState(0)

	const springs = useSprings(
		modalPhotos.length,
		modalPhotos.map((image, i) => ({
			transform: interpolate(
				[(i - index) * 100 + '%', (i - index + 1) * 100 + '%'],
				x => `translateX(${x})`
			),
		}))
	)

	const handlePrev = () => {
		setIndex(prevIndex =>
			prevIndex === 0 ? modalPhotos.length - 1 : prevIndex - 1
		)
	}

	const handleNext = () => {
		setIndex(prevIndex =>
			prevIndex === modalPhotos.length - 1 ? 0 : prevIndex + 1
		)
	}

	return (
		<Modal
			className='modal-product'
			isActive={isModal}
			setIsActive={setIsModal}
		>
			<div className='wrapper'>

				<div className='photos'>

					<button className='left arrow' onClick={handlePrev}>
						<IoIosArrowBack />
					</button>

					{springs.map((style, i) => {
						const type = modalPhotos[i].endsWith('.pdf') ? 'document' : 'image'

						return (
							<animated.div className='photo-container' key={i} style={{...style}}>
								{type == 'image' ? (
									<img className={`${modalPhotosHeight ? modalPhotosHeight : ''}`} src={modalPhotos[i]} alt={modalPhotos[i]} />
								) : type == 'document' && (

									window.innerWidth > 768 ? (
										<iframe src={modalPhotos[i]}/>
									) : (
										<div className='open-document'>
											<GrDocument />
											<span>{modalPhotos[i]}</span>
											<a href={modalPhotos[i]} target='_blank'>Open Document</a>
										</div>
									)
								)}


							</animated.div>
						)
					})}

					<button className='right arrow' onClick={handleNext}>
						<IoIosArrowForward />
					</button>

          <div className='dots-bar'>
            {modalPhotos.map((img, i) => (
              <div key={i} className='dot'>
                {i === index ? <GoDotFill className='active' /> : <GoDot />}
              </div>
            ))}
          </div>
          
				</div>

        <div className="text">
          <h1 className='title'>{title}</h1>

          <p className='description'>{modalDescription}</p>
        </div>


			</div>
		</Modal>
	)
}
